// extracted by mini-css-extract-plugin
export default {"landingRoot":"landing_landingRoot__wdxhQ","navLink":"landing_navLink__q9h4a","supportHero":"landing_supportHero__8BRzt","supportWrapper":"landing_supportWrapper__wl0BL"};